import { BrowserRouter, Routes, Route } from "react-router-dom"
import SsoSessionBootstrap from "./components/SsoSessionBootstrap"
import { APP_BASE } from "./config/paths"
import { AdminFeedbackProvider } from "./context/AdminFeedbackContext"

import Home from "./pages/Home"
import Login from "./pages/Login"
import NDA from "./pages/NDA"
import AdminDashboard from "./pages/AdminDashboard"
import Widgets from "./pages/Widgets"
import UploadDocs from "./pages/UploadDocs"
import ProspectRegister from "./pages/ProspectRegister"
import Admins from "./pages/Admins"
import NDAManagement from "./pages/NDAManagement"
import Settings from "./pages/Settings"
import LoginHistory from "./pages/LoginHistory"
import AuditLog from "./pages/AuditLog"
import ProfileSettings from "./pages/ProfileSettings"
import NotFound from "./pages/NotFound"

// Admin screens share one toast/confirm-dialog provider so every admin action
// (approve, reject, delete, upload, etc.) gets consistent, accessible feedback
// instead of native alert()/confirm()/prompt().
function withAdminFeedback(element) {
    return <AdminFeedbackProvider>{element}</AdminFeedbackProvider>
}

function App() {

    return (
        <BrowserRouter basename={APP_BASE || undefined}>
            <SsoSessionBootstrap>
            <Routes>

                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />

                <Route path="/nda" element={<NDA />} />

                <Route path="/admin" element={withAdminFeedback(<AdminDashboard />)} />
                <Route path="/admin/ndas" element={withAdminFeedback(<NDAManagement />)} />

                <Route path="/widgets" element={withAdminFeedback(<Widgets />)} />

                <Route path="/upload" element={withAdminFeedback(<UploadDocs />)} />

                <Route path="/prospect-register" element={<ProspectRegister />} />

                <Route path="/admins" element={withAdminFeedback(<Admins />)} />

                <Route path="/settings" element={withAdminFeedback(<Settings />)} />

                <Route path="/login-history" element={withAdminFeedback(<LoginHistory />)} />

                <Route path="/audit-log" element={withAdminFeedback(<AuditLog />)} />

                <Route path="/profile" element={<ProfileSettings />} />

                <Route path="*" element={<NotFound />} />

            </Routes>
            </SsoSessionBootstrap>
        </BrowserRouter>
    )
}

export default App